import { Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { FinancialUtils } from '../utils/financial';

@Pipe({ name: 'toCents' })
export class ToCentsPipe implements PipeTransform {
  @memoize()
  public transform(value: number): any {
    return FinancialUtils.toCents(value);
  }
}
